/** @deprecated Préférez getSchlConfig(...).replacementReserve.elevator */
export const SCHL_ELEVATOR_REPLACEMENT_RESERVE_MONTHLY_LEGACY = 300;

/** Barème 2025-2026 (8 juin 2026) — toutes provinces, ossature bois */
export const SCHL_ELEVATOR_REPLACEMENT_RESERVE_MONTHLY_LATEST = 315;

/** Repli UI si la config SCHL n’est pas encore résolue */
export const SCHL_ELEVATOR_REPLACEMENT_RESERVE_MONTHLY =
  SCHL_ELEVATOR_REPLACEMENT_RESERVE_MONTHLY_LATEST;

export function annualElevatorReplacementReserve(
  numElevators,
  monthlyRate = SCHL_ELEVATOR_REPLACEMENT_RESERVE_MONTHLY_LATEST,
) {
  const n = parseInt(numElevators, 10) || 0;
  const rate = parseFloat(monthlyRate) || 0;
  return n * rate * 12;
}
